{
  "nl": {
    "bookmark": {
      "hints": {
        "body": "Ontdek nu gratis lesmateriaal in de fobizz-galerie en haal inspiratie voor je lessen. Je kunt het materiaal opslaan door op het <i class='bi bi-heart'></i> te klikken.",
        "title": "Je markeerlijst is nog leeg"
      },
      "links": {
        "toMaterial": "Lesmateriaal ontdekken"
      },
      "title": "Opgeslagen lesmateriaal"
    }
  }
}
